// import lazyLoading from '../lazyLoading';

export default {
  name: 'reportmoduleiframe',
  caption: 'Rapor Modülü Iframe',
  wdm16_id: '',
  icon: 'icon-cursor',
  path: '/reportmoduleiframe',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
